import React from 'react';
import { useAuth } from '../Context/AuthContext';
import { Card, CardBody, Container, Row, Col, Button } from 'reactstrap';
import { H3, P } from '../AbstractElements';
import { ShieldOff } from 'react-feather';

interface PermissionRouteProps {
    permission: string;
    children: React.ReactNode;
}

export default function PermissionRoute({ permission, children }: PermissionRouteProps) {
    const { hasPermission, isLoading } = useAuth();

    if (isLoading) return null;

    if (!hasPermission(permission)) {
        return (
            <div className="page-body">
                <Container fluid>
                    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 'calc(100vh - 180px)' }}>
                        <Col md="8" lg="5" xl="4">
                            <Card className="border-0 shadow-lg" style={{ borderRadius: '32px', background: '#fff' }}>
                                <CardBody className="p-5 text-center">
                                    <div className="position-relative mb-5 d-inline-block">
                                        <div className="position-absolute top-50 start-50 translate-middle" style={{
                                            width: '120px',
                                            height: '120px',
                                            backgroundColor: 'rgba(48, 142, 135, 0.08)',
                                            borderRadius: '50%',
                                            filter: 'blur(20px)'
                                        }} />
                                        <div className="d-flex align-items-center justify-content-center" style={{
                                            width: '100px',
                                            height: '100px',
                                            backgroundColor: '#f8fdfc',
                                            borderRadius: '30px',
                                            boxShadow: '0 10px 30px rgba(48, 142, 135, 0.1)',
                                            transform: 'rotate(-5deg)'
                                        }}>
                                            <ShieldOff size={48} color="#308e87" strokeWidth={1.5} />
                                        </div>
                                    </div>

                                    <H3 className="fw-bold mb-3" style={{ color: '#1a202c', letterSpacing: '-0.02em', fontSize: '1.75rem' }}>
                                        Access Denied
                                    </H3>

                                    <P className="text-muted mb-5 px-3" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
                                        Oops! It looks like you don't have the permissions to access this page.
                                        Please reach out to your administrator to request access.
                                    </P>

                                </CardBody>
                            </Card>
                        </Col>
                    </div>
                </Container>
            </div>
        );
    }



    return <>{children}</>;
}
